import { render, staticRenderFns } from "./LayoutBaseContent.vue?vue&type=template&id=3dfe8b2d"
import script from "./LayoutBaseContent.vue?vue&type=script&lang=js"
export * from "./LayoutBaseContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports